import { Injectable } from '@angular/core';
import { PatchMultiClientAcessDto } from '@app/data/auth/dto/patch-multi-client-acess.dto';
import { AuthRepository } from '@data/auth/auth.repository';
import { AuthService } from '@infra/auth/auth.service';
import { map } from 'rxjs';

@Injectable()
export class ClientChangeController {
  constructor(
    private authService: AuthService,
    private authRepository: AuthRepository,
  ) {}

  clientChange(data: PatchMultiClientAcessDto) {
    return this.authRepository.patchMultiClientAccess(data).pipe(
      map((item) => {
        this.authService.credentials = item;
        return item;
      })
    );
  }
}
